import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import toaster from 'react-hot-toast';
import { CentsAssistInfo } from '~api/assist/getCentsAssistInfo';
import { EditCentsAssistInfoPayload, editCentsAssistInfo } from 'api/assist/editCentsAssistInfo';

export const useEditCentsAssistInfo = () => {
  return useMutation<
    AxiosResponse<CentsAssistInfo>,
    AxiosError<{ error: string }>,
    EditCentsAssistInfoPayload
  >({
    mutationFn: async (data) => {
      return editCentsAssistInfo(data);
    },
    onSuccess: async () => {
      toaster('Cents Assist info has been saved', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while saving Cents Assist info', {
        icon: '❌',
      });
      return error;
    },
  });
};
